// extracted by mini-css-extract-plugin
export default {"page-wrapper":"styles_page-wrapper__J9lUX","ssr-layout":"styles_ssr-layout__vZQDz","sideMenuButton":"styles_sideMenuButton__G+Yrl","menuIcon":"styles_menuIcon__6xYuU"};